import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import Country from '../../../../../types/country/Country';
import PhysicalSampleFirmwareUpgradeDTO from '../../../../../types/physical-sample/PhysicalSampleFirmwareUpgradeDTO';
import Studio from '../../../../../types/studio/Studio';
import { IsAdminDirective } from '../../../directives/is-admin.directive';
import { EnumLabelPipe } from '../../../pipes/enum-label.pipe';
import { StudioService } from '../../../services/studio.service';
import { FirmwareUpgradeTriggerService } from '../../shared/physical-samples/firmware-upgrade-trigger.service';
import {
    UpgradePhysicalSampleFirmwareDialogComponent
} from '../../shared/physical-samples/upgrade-physical-sample-firmware-dialog/upgrade-physical-sample-firmware-dialog.component';

/** Reuses the shared scope-selection dialog and FirmwareUpgradeTriggerService from Physical Samples. */
@Component({
    selector: 'app-trigger-firmware-rollout',
    templateUrl: './trigger-firmware-rollout.component.html',
    styleUrl: './trigger-firmware-rollout.component.scss',
    providers: [ FirmwareUpgradeTriggerService ],
    imports: [
        Button,
        TableModule,
        Tag,
        IsAdminDirective,
        UpgradePhysicalSampleFirmwareDialogComponent,
        EnumLabelPipe
    ]
})
export class TriggerFirmwareRolloutComponent implements OnInit {

    @Output() public rolloutTriggered: EventEmitter<void> = new EventEmitter<void>();

    public displayUpgradeFirmwareDialog = false;
    public allAvailableStudios: Studio[] = [];
    public allAvailableCountries: Country[] = [];

    constructor(
        public trigger: FirmwareUpgradeTriggerService,
        private studioService: StudioService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {
    }

    public ngOnInit(): void {
        this.loadAllStudiosAndCountries();
    }

    public openUpgradeFirmwareDialog(): void {
        this.displayUpgradeFirmwareDialog = true;
    }

    public choosePhysicalSampleForFirmwareUpgrade(physicalSampleFirmwareUpgradeDTO: PhysicalSampleFirmwareUpgradeDTO): void {
        this.trigger.choosePhysicalSampleForFirmwareUpgrade(physicalSampleFirmwareUpgradeDTO, this.allAvailableStudios);
    }

    public enableManualSelection(): void {
        this.trigger.enableManualSelection();
    }

    public cancelRolloutTrigger(): void {
        this.trigger.reset();
    }

    public triggerFirmwareUpgrade(): void {
        this.confirmationService.confirm({
            message: this.trigger.confirmationMessage(),
            header: 'Confirm Firmware Upgrade',
            icon: 'pi pi-exclamation-triangle',
            accept: () => this.trigger.submit()
                .then(() => this.rolloutTriggered.emit())
                .catch(() => { /* error already surfaced via toast by the trigger service */
                })
        });
    }

    /** Loads the full studio fleet so Country/Global scope options cover every studio, not just one page. */
    private loadAllStudiosAndCountries(): void {
        this.studioService.getAllStudios()
            .then(studios => {
                this.allAvailableStudios = studios;
                this.allAvailableCountries = studios
                    .map(studio => studio.dealership?.country)
                    .filter((country): country is Country => !!country && country.id != null)
                    .filter((country, index, self) =>
                        index === self.findIndex(i => i.id === country.id));
            })
            .catch((error: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
            });
    }

}
